import {isToday, isYesterday} from '../isLocalEqual';
import {inclinedMonthNames} from './months';
import {today, yesterday} from './days';

export function formatDate(timestamp: UnixTimeStamp): LocalDateTimeFormatted {
  const dateObject = new Date(timestamp);
  const month = dateObject.getMonth();
  const date = dateObject.getDate();

  return `${date} ${inclinedMonthNames[month]}`;
}

export function humanizeDate(timestamp: UnixTimeStamp): LocalDateTimeFormatted {
  if (isToday(timestamp)) return today;
  if (isYesterday(timestamp)) return yesterday;
  return formatDate(timestamp);
}

function padLeft(value: number): string {
  return value < 10 ? `0${value}` : `${value}`;
}

export function formatTime(timestamp: UnixTimeStamp): LocalDateTimeFormatted {
  const dateObject = new Date(timestamp);
  const hours = dateObject.getHours();
  const mins = dateObject.getMinutes();

  return `${padLeft(hours)}:${padLeft(mins)}`;
}

export function formatDateTime(timestamp: UnixTimeStamp): LocalDateTimeFormatted {
  const date = humanizeDate(timestamp);
  const time = formatTime(timestamp);
  return `${date}, ${time}`;
}
